<!--<app-header></app-header>-->
<app-header2></app-header2>
<app-sidebar></app-sidebar>
<app-right-sidebar></app-right-sidebar>
<div [dir]="direction" >
<section class="content">
  <router-outlet></router-outlet>
</section>
</div>
